module.exports = __webpack_public_path__ + "static/media/linkedin.921b41f8.svg";